// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"SelectHitsPerPage_selectContainer__ad2ZI","leftToRight":"SelectHitsPerPage_leftToRight__ZgViv"};